import React, { useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Two 44px circular buttons for the kid header: 🔊 sound mute toggle,
 * 🌐 language toggle (EN / العربية). Persists via localStorage and flips
 * `document.documentElement.dir/lang` live (no reload) — same convention
 * as LanguageSwitcher.jsx.
 */
export default function SoundLangControls({ theme = "dark", className = "" }) {
  const { i18n } = useTranslation();
  const [muted, setMuted] = useState(() => localStorage.getItem("kids_sound_muted") === "1");
  const isAr = i18n.language?.startsWith("ar");
  const onLight = theme === "light";

  const btnStyle = onLight
    ? { background: "#fff", color: "#2A2620", boxShadow: "0 3px 0 rgba(0,0,0,.08)" }
    : { background: "rgba(0,0,0,.16)", color: "#fff" };

  const toggleMute = () => {
    const next = !muted;
    setMuted(next);
    localStorage.setItem("kids_sound_muted", next ? "1" : "0");
  };

  const toggleLang = () => {
    const next = isAr ? "en" : "ar";
    i18n.changeLanguage(next);
    localStorage.setItem("cabil_lang", next);
    document.documentElement.dir = next === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = next;
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <button
        type="button"
        onClick={toggleMute}
        aria-label={muted ? "Unmute sound" : "Mute sound"}
        className="w-11 h-11 rounded-full flex items-center justify-center text-[18px] shrink-0"
        style={btnStyle}
      >
        {muted ? "🔇" : "🔊"}
      </button>
      <button
        type="button"
        onClick={toggleLang}
        aria-label="Switch language"
        className="w-11 h-11 rounded-full flex items-center justify-center text-[18px] shrink-0"
        style={btnStyle}
      >
        🌐
      </button>
    </div>
  );
}
